<template>

    <master-page  v-if="!loading">
        <div class="flex flex-col xl:flex-row px-14 py-8">
            <!-- <section class="w-full xl:w-1/3 relative">
                <service-menu />
            </section> -->
            <section class="w-full  mt-8 xl:mt-0">
                <div class="container-1024 mx-auto px-3">
                    <div class="flex items-center">
                        <a @click.stop.prevent="$router.go(-1)" title="Voltar" class="cursor-pointer text-brand hover:text-blue-500 text-3xl mr-2">
                            <i class="far fa-arrow-alt-circle-left"></i>
                        </a>

                        <h1 class="text-gray-500 font-bold text-2xl">
                            {{pageTitle}}
                        </h1>
                    </div>
                    <hr class="border-2 border-gray-300" />
                    <div class="p-3">
                        <list-component
                            :items="posts"
                            :paging="true"
                            :totalItems="totalItems"
                            :pageLimit="25"

                            listItemClasses="flex flex-row break-words my-2 pb-2 items-center hover:bg-gray-100 rounded-l rounded-r-xl"
                            contentImageClasses="hidden mr-1 lg:inline w-180 h-auto border border-gray-100 rounded"
                            contentTitleClasses="text-brand px-2 pt-2 inline-grid text-2xl break-words"
                            contentInfoClasses="text-base"
                            contentAbstractClasses="text-base px-2 text-gray-500 break-words"
                        />
                    </div>
                </div>
            </section>
        </div>
    </master-page>

    <Spinner v-else/>

</template>

<script>
import { reactive, onMounted } from 'vue'
import MasterPage from "@/views/MasterPage";
import ListComponent from "@/components/list";
import Spinner from '@/components/spinner'
import api from '@/services'
import eventBus from '@/event-hub'
import { useRoute } from 'vue-router'

export default {
    name: "List",

    components: {
        MasterPage,
        ListComponent,
        Spinner,
    },

    setup() {
        const route = useRoute()

        const state = reactive({
            pageTitle: 'Área de publicação não encontrada',
            totalItems: 0,
            posts: [{
                title: 'Nenhum resultado encontrado',
                info: '',
                abstract: ''
            }],
            loading: true
        });


        const update = (page) => {


            page = page || route.query.page

            if(route.path == '/search' && route.query.terms)
            {
                api.post.search(route.query.terms, page).then( data => {
                    if(data.count > 0)
                    {
                        state.posts = data.collection
                        state.totalItems = data.count
                    }
                    state.pageTitle = `Resultados da pesquisa por: "${route.query.terms}"`

                })
            }
            else
            {
                api.post.byArea(route.params.slug, {page}).then( data => {

                    if(data.count > 0)
                    {
                        state.posts = data.collection
                        state.totalItems = data.count
                        state.pageTitle = data.collection[0].area_unicode.split('/').pop().trim()
                    }
                })
            }

            state.loading = !state.loading

        }

        onMounted( update )

        eventBus.on('update:resultList', (page) => {
            update(page)
            state.loading = !state.loading

        })

        return state
    },
};
</script>

<style lang="css" scoped>
</style>